import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'get-site-branch-task' as const;

const argumentZod = z.object({
  taskId: z
    .string()
    .uuid()
    .describe(
      'Task id returned by a site-branch lifecycle tool such as stage-site-branch.'
    ),
});

export const getSiteBranchTaskManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get site branch task',
  family: 'site-branches',
  llmTool: {
    name: toolName,
    description:
      'Gets the status of an async site-branch task for the current site (e.g. the taskId from stage-site-branch). Returns status (queued, started, finished, failed), taskType, branchId, and an error when failed. Poll until status is finished or failed. A task that belongs to another site returns not found.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.SITE_BRANCHES,
  requiredScopes: ['branches:read'],
  permission: [{resource: 'Site', action: 'read'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetSiteBranchTaskArgumentType = z.infer<typeof argumentZod>;
